module.exports = __webpack_public_path__ + "img/Partner_Slowmist.d537ad45.svg";